/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { isArray, isBoolean } from 'lodash';

import Link from '../Link';
import subFeatureItemPropType from '../../../common/propTypes/subFeatureItemPropType';

import './subFeatureItem.scss';

const isImageToBeDisplayed = (isShown) => (isArray(isShown) && isShown.length)
    || (isBoolean(isShown) && isShown);

const getImageSrc = (deviceType, image) => {
    let imageSrc = '';

    if (isImageToBeDisplayed(image.displayImage)) {
        if (deviceType === 'mobile' && image.srcMobile) {
            imageSrc = image.srcMobile;
        }
        if (deviceType === 'desktop' && image.srcDesktop) {
            imageSrc = image.srcDesktop;
        }
    }
    return imageSrc;
};

const SubFeatureItem = (props) => {
    const imageSrc = getImageSrc(props.deviceType, props.data.image);

    return (
        <div styleName={`main_content ${props.deviceType}`}>
            <h1 styleName="main_content__h1">{props.data.sectionTitle}</h1>
            <div styleName="content">
                { imageSrc ? (
                    <img
                        styleName="image"
                        src={imageSrc}
                        alt={props.data.image.altText}
                        title={props.data.sectionTitle}
                    />
                ) : null }
                <div>
                    <div styleName="text" dangerouslySetInnerHTML={{ __html: props.data.text }} />
                    <div styleName="links">
                        {
                            props.data.links.map((linkItem, index) => (
                                <Link
                                    deviceType={props.deviceType}
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={index}
                                    data={linkItem}
                                />
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

SubFeatureItem.propTypes = {
    data: subFeatureItemPropType.isRequired,
    deviceType: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
};

export default SubFeatureItem;
/* eslint-enable react/destructuring-assignment */
